// const lang = require('./lang')

module.exports = (function() {
  return require('./charset/zh_cn/index')
  // switch (lang.checkLang()) {
  //   case 'zh':
  //     return require('./charset/zh_cn/index')
  //   case 'en':
  //     return require('./charset/zh_cn/index')
  //   default:
  //     return require('./charset/zh_cn/index')
  // }
})()



// WEBPACK FOOTER //
// ./src/commons/locale/index.js